/**
 * HEADER MAIN MENU VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import { Link } from 'react-router';

const Logo = () => <Link to="/start" className="header__logo" />

export default Logo;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/templates/Header.logo.jsx